import {
  SupplierDetailsGetters,
  SupplierDetailsMutations,
  SupplierDetailsActions
} from './suppliers-details.keys';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { supppliersService } from './suppliers-service';
import { attachmentService } from '../../../../components/attachments/attachment.service';
import i18n from '@/i18n';
import router from '@/router';

export const getDefaultState = () => {
  return {
    isLoading: true,
    isOnScreenSupplierModified: false,
    currentSupplier: {},
    suppliersValidationErrors: {},
    currentSupplierContractors: [],
    currentSupplierContacts: [],
    supplierContractorSortOrder: {
      sortBy: 'payrollnums',
      sortDirection: 'asc'
    },
    supplierContactSortOrder: {
      sortBy: 'contactName',
      sortDirection: 'asc'
    },
    supplierAttachments: []
  };
};

export const suppliersDetailsStore = {
  state: getDefaultState(),
  getters: {
    [SupplierDetailsGetters.CurrentSupplier]: state => {
      return state.currentSupplier;
    },
    [SupplierDetailsGetters.CurrentSupplierContractors]: state => {
      return state.currentSupplierContractors;
    },
    [SupplierDetailsGetters.SupplierContractorsSortOrder]: state => {
      return state.supplierContractorSortOrder;
    },
    [SupplierDetailsGetters.SupplierContactsSortOrder]: state => {
      return state.supplierContactSortOrder;
    },
    [SupplierDetailsGetters.CurrentSupplierContacts]: state => {
      return state.currentSupplierContacts;
    },
    [SupplierDetailsGetters.GetSupplierAttachments]: state => state.supplierAttachments
  },

  mutations: {
    [SupplierDetailsMutations.ResetSupplierState]: function(state) {
      Object.assign(state, getDefaultState());
    },
    [SupplierDetailsMutations.SetLoading]: (state, isLoading = true) => {
      state.isLoading = isLoading;
    },
    [SupplierDetailsMutations.UpdateSupplier]: (state, supplier) => {
      state.currentSupplier = supplier;
      state.isOnScreenSupplierModified = false;
    },
    [SupplierDetailsMutations.SetSupplierContractors]: (state, contractors) => {
      state.currentSupplierContractors = contractors;
    },
    [SupplierDetailsMutations.SetSupplierContractorsSortOrder]: (state, sortOrder) => {
      state.supplierContractorSortOrder = sortOrder;
    },
    [SupplierDetailsMutations.SetSupplierContacts]: (state, contacts) => {
      state.currentSupplierContacts = contacts;
    },
    [SupplierDetailsMutations.SetSupplierContactsSortOrder]: (state, sortOrder) => {
      state.supplierContactSortOrder = sortOrder;
    },
    [SupplierDetailsMutations.SetSupplierAttachments](state, attachments) {
      state.supplierAttachments = attachments;
    }
  },

  actions: {
    [SupplierDetailsActions.ResetCurrentSupplier]: function({ commit, dispatch }) {
      dispatch(TolErrorsActions.ClearAll);
      commit(SupplierDetailsMutations.ResetSupplierState);
    },
    [SupplierDetailsActions.RetrieveSupplierAttachments]: ({ commit }, referenceNumber) => {
      return attachmentService.getAttachments(referenceNumber, 'SUPPLIER').then(response => {
        commit(SupplierDetailsMutations.SetSupplierAttachments, response.data);
      });
    },
    [SupplierDetailsActions.RetrieveSupplier]: ({ commit, dispatch }, reference_number) => {
      supppliersService
        .retrieveSupplierDetails(reference_number)
        .then(supplier => {
          commit(SupplierDetailsMutations.UpdateSupplier, supplier);
          dispatch(SupplierDetailsActions.RetrieveSupplierContractors, reference_number);
          dispatch(SupplierDetailsActions.RetrieveSupplierContacts, reference_number);
          dispatch(SupplierDetailsActions.RetrieveSupplierAttachments, reference_number);
        })
        .then(() => {
          dispatch(TolErrorsActions.ClearAll);
          commit(SupplierDetailsMutations.SetLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('suppliers.details.errors.retrieveSupplier')
          });
          commit(SupplierDetailsMutations.SetLoading, false);
        });
    },
    [SupplierDetailsActions.SaveSupplierDetails]: function({ dispatch }, params) {
      let { supplierData, action } = params;
      supppliersService
        .saveSupplier(supplierData, action)
        .then(status => {
          if (status.message === 'success') {
            dispatch(SupplierDetailsActions.RetrieveSupplierContractors, status.data);
            router.replace({ path: `/suppliers/${status.data}` }).catch(error => {
              if (error.name !== 'NavigationDuplicated') {
                dispatch(TolErrorsActions.SetError, { error });
              }
            });
          } else {
            const messages = Object.values(status.errors);
            let items = [];
            for (let item of messages) {
              items = items.concat(item);
            }
            dispatch(TolErrorsActions.SetError, { items });
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [SupplierDetailsActions.RetrieveSupplierContractors]: ({ commit, state }, reference_number) => {
      return supppliersService
        .retrieveSupplierContractors(reference_number, state.supplierContractorSortOrder)
        .then(contractors => {
          for (const contractor of contractors) {
            contractor.contractorName = contractor.last_name + ',' + contractor.first_name;
          }
          commit(SupplierDetailsMutations.SetSupplierContractors, contractors);
        });
    },
    [SupplierDetailsActions.RetrieveSupplierContacts]: ({ commit, state }, reference_number) => {
      return supppliersService
        .retrieveSupplierContacts(reference_number, state.supplierContactSortOrder)
        .then(contacts => {
          for (const contact of contacts) {
            contact.contactName = contact.last_name + ',' + contact.first_name;
          }
          commit(SupplierDetailsMutations.SetSupplierContacts, contacts);
        });
    },

    [SupplierDetailsActions.UpdateSupplierContractorSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(SupplierDetailsMutations.SetSupplierContractorsSortOrder, sortOrder);
      dispatch(SupplierDetailsActions.RetrieveSupplier, state.currentSupplier.reference_number);
    },

    [SupplierDetailsActions.UpdateSupplierContactsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(SupplierDetailsMutations.SetSupplierContactsSortOrder, sortOrder);
      dispatch(SupplierDetailsActions.RetrieveSupplier, state.currentSupplier.reference_number);
    }
  }
};
